// extracted by mini-css-extract-plugin
module.exports = {"preview":"PreviewText_preview__lIScD","fade_in":"PreviewText_fade_in___sPzy"};